// extracted by mini-css-extract-plugin
export default {"GallerySection":"GallerySection_GallerySection__LOXDh","title":"GallerySection_title__9NJxq","gallery-image":"GallerySection_gallery-image__oCZLs"};